<template>
    <div class="markdown-demo p-6">
        <h2 class="text-xl font-semibold mb-4">
            📝 Markdown Editor Demo
        </h2>

        <div class="flex items-center gap-3 mb-4">
            <button
                class="px-3 py-2 bg-primary text-white rounded hover:bg-primary/80 transition"
                @click="insertExample"
            >
                insert example
            </button>
            <button
                class="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300 transition"
                @click="clearContent"
            >
                clear
            </button>
        </div>
        <MarkdownEditor v-model="content" />
    </div>
</template>

<script setup>
import { ref } from 'vue'
import MarkdownEditor from '@/components/RedesignBaseComponents/MarkdownEditor.vue'
const content = ref('')

const exampleText = ''
const insertExample = () => {
    content.value = exampleText
}

const clearContent = () => {
    content.value = ''
}
</script>

<style scoped>
.markdown-demo {
    max-width: 900px;
    margin: 0 auto;
}

.bg-primary {
    background-color: var(--primary-actions, #2563eb);
}
</style>
